import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../config";
import { Loader2 } from "lucide-react";
import SiempriaCredit from "../components/SiempriaCredit";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("admin_token", data.token);
      localStorage.setItem("admin_role", data.user.role);
      localStorage.setItem("admin_email", data.user.email);
      navigate(data.user.role === "partner" ? "/partner" : data.user.role === "entrega" ? "/entregas" : "/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Error de acceso");
    } finally {
      setBusy(false);
    }
  };

  const submitForgot = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch {
      setError("No se pudo enviar el email. Inténtalo de nuevo.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-topacio-sand flex flex-col items-center justify-center px-6 py-10" data-testid="admin-login-page">
      {forgot ? (
        <form onSubmit={submitForgot} className="w-full max-w-sm card-brutal p-8" data-testid="forgot-form">
          <div className="flex justify-center mb-8">
            <img src="/logo-topacio.jpg" alt="Rent a Moto Topacio" className="h-16 w-auto rounded-md border-2 border-topacio-ink shadow-[3px_3px_0_0_#111]" />
          </div>
          {sent ? (
            <div data-testid="forgot-success" className="text-center">
              <p className="text-sm font-bold text-topacio-ink">Si existe una cuenta con ese email, te hemos enviado un enlace para restablecer la contraseña.</p>
              <p className="text-xs text-topacio-faded mt-2">Revisa también la carpeta de spam. El enlace caduca en 1 hora.</p>
            </div>
          ) : (
            <>
              <p className="text-sm text-topacio-faded font-semibold mb-4">Te enviaremos un enlace para restablecer tu contraseña.</p>
              <input data-testid="forgot-email-input" type="email" required placeholder="Email" value={email}
                onChange={(e) => setEmail(e.target.value)} className="input-brutal" />
              {error && <p data-testid="forgot-error" className="text-topacio-red text-xs font-bold mt-3">{error}</p>}
              <button data-testid="forgot-submit-btn" disabled={busy} className="btn-primary w-full mt-6">
                {busy && <Loader2 className="w-4 h-4 animate-spin" />}
                Enviar enlace
              </button>
            </>
          )}
          <button type="button" data-testid="forgot-back-btn" onClick={() => { setForgot(false); setSent(false); setError(""); }}
            className="w-full text-center text-xs font-extrabold text-topacio-faded hover:text-topacio-ink transition-colors mt-5 underline underline-offset-2">
            ← Volver a entrar
          </button>
        </form>
      ) : (
        <form onSubmit={submit} className="w-full max-w-sm card-brutal p-8">
          <div className="flex justify-center mb-8">
            <img src="/logo-topacio.jpg" alt="Rent a Moto Topacio" className="h-16 w-auto rounded-md border-2 border-topacio-ink shadow-[3px_3px_0_0_#111]" />
          </div>
          <input data-testid="admin-email-input" type="email" required placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} className="input-brutal" />
          <input data-testid="admin-password-input" type="password" required placeholder="Contraseña" value={password}
            onChange={(e) => setPassword(e.target.value)} className="input-brutal mt-4" />
          {error && <p data-testid="admin-login-error" className="text-topacio-red text-xs font-bold mt-3">{error}</p>}
          <button data-testid="admin-login-btn" disabled={busy} className="btn-primary w-full mt-6">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />}
            Entrar
          </button>
          <button type="button" data-testid="forgot-link" onClick={() => { setForgot(true); setError(""); }}
            className="w-full text-center text-xs font-extrabold text-topacio-faded hover:text-topacio-red transition-colors mt-4 underline underline-offset-2">
            ¿Olvidaste tu contraseña?
          </button>
        </form>
      )}
      <SiempriaCredit />
    </div>
  );
}
